import { useCallback } from 'react';
import { type PositionInput, useChatWidgetPositionStore } from './store';

const useChatWidget = () => {
  const isFooterVisible = useChatWidgetPositionStore((s) => s.isFooterVisible);
  const setStorePosition = useChatWidgetPositionStore((s) => s.setPosition);

  const setPosition = useCallback(
    (position: PositionInput) => {
      setStorePosition(position);
    },
    [setStorePosition]
  );

  const hide = useCallback((hideIt: boolean) => {
    // Intercom's default launcher stays hidden always — the AIChatFloatingButton FAB
    // is the only entry point. We only collapse the messenger panel when hiding.
    if (hideIt) window.Intercom?.('hide');
  }, []);

  const openIntercom = useCallback(() => {
    window.Intercom?.('show');
  }, []);

  const closeIntercom = useCallback(() => {
    window.Intercom?.('hide');
  }, []);

  const sendIntercomMessage = useCallback((message: string) => {
    window.Intercom?.('showNewMessage', message);
  }, []);

  return {
    setPosition,
    hide,
    openIntercom,
    closeIntercom,
    sendIntercomMessage,
    isFooterVisible,
  };
};

export default useChatWidget;
